import { FC } from "react";
import Markdown from "react-markdown";

import rehypeRaw from "rehype-raw";
import rehypeSanitize, { defaultSchema } from "rehype-sanitize";

import { insertDomain } from "@/service/ApplicationQueries";

interface IMarkdowContentRenderer {
  className?: string;
  isNotProcedureRender?: boolean;
  content: string | undefined;
  rehypePlugins?: Markdown.PluggableList | undefined;
  insertDomainOptions?: { insertIntoHtmlElement: boolean };
  linkTarget?: string;
  OnClickImage?: () => void;
}

export const SATOSContentRender: FC<IMarkdowContentRenderer> = (props) => {
	const customSchema = {
		...defaultSchema,
		tagNames: [...(defaultSchema.tagNames || []), "u", "td"], // Add <u> tag
		attributes: {
			...(defaultSchema.attributes || {}),
			div: [
				...(defaultSchema.attributes?.div || []),
				"style",
				["className", "vdd-added", "vdd-removed", "vdd-modified"],
				["id", "vdd-added", "vdd-removed", "vdd-modified"],
			],
			span: [
				...(defaultSchema.attributes?.span || []),
				"style",
				["className", "vdd-added", "vdd-removed", "vdd-modified"],
				["id", "vdd-added", "vdd-removed", "vdd-modified"],
			],
			img: [
				...(defaultSchema.attributes?.img || []),
				"style",
				"width",
				"height",
				["className", "vdd-added", "vdd-removed", "vdd-modified"],
				["id", "vdd-added", "vdd-removed", "vdd-modified"],
			],
			table: [
				...(defaultSchema.attributes?.table || []),
				["className", "vdd-added", "vdd-removed", "vdd-modified"],
				["id", "vdd-added", "vdd-removed", "vdd-modified"],
			],
			thead: [
				...(defaultSchema.attributes?.thead || []),
				["className", "vdd-added", "vdd-removed", "vdd-modified"],
				["id", "vdd-added", "vdd-removed", "vdd-modified"],
			],
			tbody: [
				...(defaultSchema.attributes?.tbody || []),
				["className", "vdd-added", "vdd-removed", "vdd-modified"],
				["id", "vdd-added", "vdd-removed", "vdd-modified"],
			],
			tfoot: [
				...(defaultSchema.attributes?.tfoot || []),
				["className", "vdd-added", "vdd-removed", "vdd-modified"],
				["id", "vdd-added", "vdd-removed", "vdd-modified"],
			],
			tr: [
				...(defaultSchema.attributes?.tr || []),
				["className", "vdd-added", "vdd-removed", "vdd-modified"],
				["id", "vdd-added", "vdd-removed", "vdd-modified"],
			],
			td: [
				...(defaultSchema.attributes?.td || []),
				["className", "vdd-added", "vdd-removed", "vdd-modified"],
				["id", "vdd-added", "vdd-removed", "vdd-modified"],
			],
			th: [
				...(defaultSchema.attributes?.th || []),
				["className", "vdd-added", "vdd-removed", "vdd-modified"],
				["id", "vdd-added", "vdd-removed", "vdd-modified"],
			],
			u: [
				...(defaultSchema.attributes?.u || []),
				["className", "vdd-added", "vdd-removed", "vdd-modified"],
				["id", "vdd-added", "vdd-removed", "vdd-modified"],
			],
		},
	};

	const plugins = props.rehypePlugins
		? [props.rehypePlugins, rehypeRaw, [rehypeSanitize, customSchema]]
		: [rehypeRaw, [rehypeSanitize, customSchema]];

	const options = props.insertDomainOptions ?? {
		insertIntoHtmlElement: true,
		markdown: true,
	};

	const linkTarget = props.linkTarget ? props.linkTarget : "_blank";

	if (!props.content) {
		return <></>;
	}

  return (
    <Markdown
      className={props.isNotProcedureRender
        ? (props.className ? `satos-content ${props.className}` : "satos-content")
        : props.className}
      rehypePlugins={plugins}
      linkTarget={linkTarget}
    >
      {insertDomain(props.content, options)}
    </Markdown>
  );
};